import PoolSelectionRow from "./PoolSelectionRow"

export  interface PoolSelectionHistoryRow {
  SelectionInterval: string
  SelectionMethod: string
  Period: string
  PoolSize: number
  SelectionDate: string
  DrugSelected: number 
  AlcoholSelected: number 
  DrugExtra: number
  AlcoholExtra: number
  DrugCompleted: number
  AlcoholCompleted: number
  DrugNotComplete: number
  AlcoholNotComplete: number
  DrugPending: number
  AlcoholPending: number
  DrugExcused: number
  AlcoholExcused: number
  PoolSelectionID: number
  UseCrews: number

 }


export default interface PoolSelectionHistory {
  Records: PoolSelectionHistoryRow[]
  Pages: number
  Total: number
}

export function createPoolSelectionRow(hstRow : PoolSelectionHistoryRow) : PoolSelectionRow
{

  let result = {PoolSelectionID: hstRow.PoolSelectionID,
    Period:  hstRow.Period,
    TimePeriod: "",
    PoolSize: hstRow.PoolSize,
    SelectionDate: hstRow.SelectionDate,
    DrugSelected: hstRow.DrugSelected,
    AlcoholSelected: hstRow.AlcoholSelected,
    DrugExtra: hstRow.DrugExtra,
    AlcoholExtra: hstRow.AlcoholExtra,
    DrugCompleted: hstRow.DrugCompleted,
    AlcoholCompleted: hstRow.AlcoholCompleted,
    DrugExcused: hstRow.DrugExcused,
    AlcoholExcused: hstRow.AlcoholExcused
  }
  return result
}
